import { Text } from '@chakra-ui/react';
import AddTokenButton from '@ui/components/AddTokenButton';
import { COIN_MODE, useCoinMode } from '@ui/hooks/useCoinMode';
import { useTranslations } from '@ui/i18n';

export const useStakeHint = (): {
  title: string;
  shortText: string;
  shortTextDesktop?: JSX.Element;
  longText: JSX.Element;
} => {
  const t = useTranslations();
  const globalCoinMode = useCoinMode();
  const mode = COIN_MODE[globalCoinMode];

  return {
    title: t(`Stake {coin} & use {liquidCoin}`, {
      coin: mode.name,
      liquidCoin: mode.liquidName,
    }),
    longText: (
      <>
        {t(`stake-${globalCoinMode}-how-it-works-desc-{br}`, {
          br: () => <br />,
        })}
        <br />
        <br />
        <AddTokenButton
          mb="20px"
          tokenType={mode.liquidTokenType}
          text={t('Add {coin} to wallet', {
            coin: mode.liquidName,
          })}
        />
      </>
    ),
    shortText:
      t(`stake-${globalCoinMode}-how-it-works-desc-{br}`, {
        br: () => '',
      }).slice(0, 69) + '...',
    shortTextDesktop: (
      <>
        <Text color="black" fontWeight="bold" display="inline">
          {t('Stake')}:{' '}
        </Text>
        {t(`stake-${globalCoinMode}-how-it-works-desc-{br}`, {
          br: () => '',
        }).slice(0, 122)}
        ...
      </>
    ),
  };
};
